<template>
  <div class="home">
    <div class="content1" :style="{backgroundImage: 'url(' + bannerBg + ')'}">
      <div class="contain">
        <h1 class="wow fadeInUp">{{$t('content1_h1')}}</h1>
        <p class="wow fadeInUp" data-wow-delay="0.2s">{{$t('content1_p')}}</p>
        <!-- <div class="learn clearfix wow fadeInUp" data-wow-delay="0.2s">
          <span @click="showModal" class="fl">{{$t('content1_learn')}}</span>
          <div @click="showModal" class="play fl">
            <img src="../../assets/icon/icon_Play.png" srcset="../../assets/icon/icon_Play@2x.png 2x">
          </div>
        </div> -->
      </div>
    </div>
    <div class="content2">
      <div class="contain">
        <h1 class="wow fadeInUp">{{$t('content2_h1')}}</h1>
        <div class="picTxt">
          <div class="pic">
            <img src="../../assets/img/shu.png" srcset="../../assets/img/shu@2x.png 2x">
          </div>
          <div class="txt">
            <p class="text wow fadeInUp">{{$t('content2_p1')}}<br><br>{{$t('content2_p2')}}<br>{{$t('content2_p3')}}<br>{{$t('content2_p4')}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content3">
      <div class="contain">
        <div class="max960">
          <h3 class="wow fadeInUp">{{$t('content3_h3')}}</h3>
          <p class="wow fadeInUp text">{{$t('content3_text1')}}</p>
        </div>
        <div class="picTxt clearfix">
          <div class="wow fadeInUp pic fr">
            <img src="../../assets/img/money.png" srcset="../../assets/img/money@2x.png 2x">
          </div>
          <div class="txt fl">
            <h3 class="wow fadeInUp max960">{{$t('content3_h3')}}</h3>
            <p class="wow fadeInUp text max960">{{$t('content3_text1')}}</p>
            <h5 class="wow fadeInUp">{{$t('content3_h5_1')}}</h5>
            <p class="wow fadeInUp text">{{$t('content3_text2')}}</p>
            <div class="wow fadeInUp logoIcon">
              <img src="../../assets/icon/acornIcon.png" srcset="../../assets/icon/acornIcon@2x.png 2x">
            </div>
            <h5 class="wow fadeInUp ">{{$t('content3_h5_2')}}</h5>
            <p class="wow fadeInUp text mb15">{{$t('content3_text3')}}</p>
            <div class="wow fadeInUp linkBtn">
              <a href="https://acornbox.org/">{{$t('content3_download')}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content4">
      <div class="contain">
        <div class="picTxt clearfix">
          <div class="wow fadeInUp pic fl">
            <img src="../../assets/img/Image_Developer.png" srcset="../../assets/img/Image_Developer@2x.png 2x">
          </div>
          <div class="txt fr">
            <h3 class="wow fadeInUp">{{$t('content4_h3')}}</h3>
            <p class="wow fadeInUp text">{{$t('content4_text1')}}</p>
            <div class="btns">
              <a class="wow fadeInUp" href="https://docs.ma.ro">SDK Docs</a>
              <a class="wow fadeInUp" href="https://github.com/TTCECO">Github</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content5" v-if="showDapp">
      <div class="contain">
        <h3 class="wow fadeInUp">{{$t('content5_h3')}}</h3>
        <p class="wow fadeInUp text">{{$t('content5_text1')}}</p>
        <div class="wow fadeInUp swiperBox">
          <swiper :options="swiperOption" style="overflow: unset;">
            <swiper-slide class="slide workbox">
              <div class="iconTxt">
                <a href="http://workbox.org/#/" target="_blank">
                  <div class="iconLogo">
                    <img src="../../assets/icon/workbox@1x.png" srcset="../../assets/icon/workbox@2x.png 2x">
                  </div>
                  <h4>WorkBox</h4>
                  <p>{{$t('content5_workbox')}}</p>
                </a>
              </div>
              <div class="hoverTxt">
                <img src="../../assets/img/texture.png" alt="" class="bg">
                <a href="http://workbox.org/#/" target="_blank">{{$t('content1_learn')}} ></a>
              </div>
            </swiper-slide>
            <swiper-slide class="slide tata">
              <div class="iconTxt">
                <a href="http://tataufo.com" target="_blank">
                  <div class="iconLogo">
                    <img src="../../assets/icon/tata@1x.png" srcset="../../assets/icon/tata@2x.png 2x">
                  </div>
                  <h4>tata</h4>
                  <p>{{$t('content5_tata')}}</p>
                </a>
              </div>
              <div class="hoverTxt">
                <img src="../../assets/img/texture.png" alt="" class="bg">
                <a href="http://tataufo.com" target="_blank">{{$t('content1_learn')}} ></a>
              </div>
            </swiper-slide>
            <swiper-slide class="slide git">
              <div class="iconTxt">
                <a href="https://git.eco" target="_blank">
                  <div class="iconLogo">
                    <img src="../../assets/icon/git@1x.png" srcset="../../assets/icon/git@2x.png 2x">
                  </div>
                  <h4>git</h4>
                  <p>{{$t('content5_git')}}</p>
                </a>
              </div>
              <div class="hoverTxt">
                <img src="../../assets/img/texture.png" alt="" class="bg">
                <a href="https://git.eco" target="_blank">{{$t('content1_learn')}} ></a>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="wow fadeInUp linkBtn">
          <a href="https://docs.google.com/forms/d/15mvbOj5AMLSZloTakOwDxDUlzBRmsd45G36VCC6PrSo/viewform?edit_requested=true">{{$t('content5_apply')}}</a>
        </div>
      </div>
      <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>  <!-- 箭头左 -->
      <div class="swiper-button-next swiper-button-white" slot="button-next"></div>  <!-- 箭头右 -->
    </div>
    <div class="content6">
      <div class="contain">
        <div class="picTxt">
          <div class="wow fadeInUp pic">
            <img src="../../assets/img/Image_island.png" alt="">
          </div>
          <div class="txt">
            <h3 class="wow fadeInUp">{{$t('content6_h3')}}</h3>
            <p class="wow fadeInUp text">{{$t('content6_text1')}}</p>
            <div class="wow fadeInUp linkBtn">
              <a href="http://ma.ro">{{$t('content6_learn')}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频窗口 -->
    <div class="modal fullsize fade" id="headerVideoModal" tabindex="-1" role="dialog" aria-labelledby="HeaderVideoModalTitle" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content text-center ">
          <button class="close" data-dismiss="modal" aria-label="Close" @click="hideModal">X</button>
          <iframe id="youtube" class="ttc-youtube-player" :src="videoSrc" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  data () {
    return {
      showDapp: false,
      videoSrc: '',
      bannerBg: require('../../assets/img/bannerBg.png'),
      swiperOption: {
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      pageScrollTop: 0
    }
  },
  methods: {
    showModal () {
      this.videoSrc = 'https://www.youtube.com/embed/ROhLyHpXh1c?rel=0&amp;controls=1&amp;showinfo=1&autoplay=0&enablejsapi=1'
      $('.ttc-youtube-player').each(function () {
        this.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
      })
      $('#headerVideoModal').show()
    },
    hideModal () {
      this.videoSrc = ''
      $('.ttc-youtube-player').each(function () {
        this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
      })
      $('#headerVideoModal').hide()
    }
  },
  mounted () {
    // let that = this
    // window.onscroll = function () {
    //   var osTop = document.documentElement.scrollTop || document.body.srcollTop || 0
    //   console.log(osTop)
    //   that.pageScrollTop = -osTop * 0.1
    // }
  }
}
</script>
<style lang="less" scoped>
.home{
  .content1{
    height: 100vh;
    min-height: 600px;
    background: #07542d;
    background-size: contain;
    background-position: left bottom;
    background-repeat: no-repeat;
    .contain{
      padding-top: 16%;
      h1{
        max-width: 1415px;
        color: #ffffff;
        margin-bottom: 30px;
      }
      p{
        max-width: 1077px;
        font-size: 20px;
        font-family: GothamPro;
        color: #FFFFFF;
        line-height: 24px;
        margin-bottom: 50px;
      }
      .learn{
        opacity: 0;
        display: inline-block;
        cursor: pointer;
        &:hover {
          span {
            margin-right: 0;
          }
        }
        span{
          width: 210px;
          height: 58px;
          background: #1DBF77;
          display: inline-block;
          font-size: 20px;
          font-family: GothamPro-Medium, GothamPro;
          font-weight: 500;
          color: #fff;
          line-height: 58px;
          text-align: center;
          cursor: pointer;
          transition: .2s;
          margin-right: 15px;
        }
        .play{
          display: inline-block;
        }
      }
    }
  }
  .content2{
    .contain{
      padding-top: 240px;
      position: relative;
      h1{
        max-width: 808px;
        position: absolute;
        top: 397px;
        left: 0;
      }
      .picTxt{
        padding-left: 294px;
        .pic{
          max-width: 569px;
          margin-bottom: 20px;
        }
        .txt{
          margin-bottom: 346px;
        }
      }
    }
  }
  .content3{
    .contain{
      .max960{
        margin-bottom: 40px;
        display: none;
      }
      .picTxt{
        margin-bottom: 340px;
        .txt{
          max-width: 760px;
          .max960{
            display: block;
          }
          h3{
            margin-bottom: 20px;
          }
          .text{
            margin-bottom: 40px;
          }
          .logoIcon{
            width: 80px;
            margin-bottom: 10px;
          }
          .mb15{
            margin-bottom: 15px;
          }
        }
        .pic{
          width: 760px;
        }
      }
    }
  }
  .content4{
    .contain{
      .picTxt{
        margin-bottom: 340px;
        .pic{
          width: 760px;
        }
        .txt{
          max-width: 760px;
          padding-top: 168px;
          h3{
            margin-bottom: 20px;
          }
          .text{
            margin-bottom: 40px;
          }
          .btns{
            a{
              display: inline-block;
              width: 149px;
              height: 58px;
              border: 2px solid #8B99A5;
              text-align: center;
              line-height: 58px;
              font-size: 20px;
              font-family: GothamPro;
              color: #8b99a5;
              margin-right: 30px;
              &:hover {
                border-color: #1DBF77;
                color: #1DBF77;
              }
              &:last-child{
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
  .content5{
    position: relative;
    overflow: hidden;
    .contain{
      margin-bottom: 340px;
      h3{
        margin-bottom: 20px;
        max-width: 1010px;
      }
      .text{
        max-width: 760px;
        margin-bottom: 50px;
      }
      .swiperBox{
        margin-bottom: 50px;
        .slide{
          width: 280px;
          height: 283px;
          box-shadow: 5px 20px 20px 0px rgba(0, 0, 0, 0.22);
          position: relative;
          margin-right: 14px;
          .iconTxt{
            a{
              padding: 30px 30px 0;
              display: block;
              .iconLogo{
                height: 76px;
                margin-bottom: 20px;
                img{
                  height: 100%;
                }
              }
              h4{
                margin: 0;
                font-size: 24px;
                font-family: GothamPro-Bold, GothamPro;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 29px;
                margin-bottom: 10px;
              }
              p{
                font-size: 16px;
                font-family: GothamPro;
                color: #FFFFFF;
                line-height: 22px;
              }
            }
          }
          .hoverTxt{
            display: none;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            text-align: center;
            overflow: hidden;
            .bg{
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              opacity: 0;
              transition: .2s;
            }
            a{
              font-size: 24px;
              font-family: GothamPro-Bold, GothamPro;
              font-weight: bold;
              color: #FFFFFF;
              line-height: 29px;
              display: inline-block;
              text-decoration: underline;
              position: absolute;
              top: 134px;
              left: 0;
              right: 0;
              margin: 0 auto;
              opacity: 0;
            }
            &:hover{
              -webkit-transition: .2s;
              transition: .2s;
              -webkit-transform: scale(1.05);
              transform: scale(1.05);
              .bg{
                opacity: 1;
              }
              a{
                opacity: 1;
              }
            }
          }
          &:last-child{
            margin-right: 0;
          }
          &:hover{
            .hoverTxt{
              display: block;
            }
          }
          &.tata{
            background: linear-gradient(135deg, #009FFE 0%, #0043C8 100%);
            .hoverTxt{
              background: linear-gradient(135deg, #009FFE 0%, #0043C8 100%);
            }
          }
          &.alive{
            background: linear-gradient(135deg,#5ca8e8,#b63eab);
            .hoverTxt{
              background: linear-gradient(135deg,#5ca8e8,#b63eab);
            }
          }
          &.cobak{
            background: linear-gradient(135deg,#3457f2,#0a0e69);
            .hoverTxt{
              background: linear-gradient(135deg,#3457f2,#0a0e69);
            }
          }
          &.socdoc{
            background: linear-gradient(135deg,#c23b59,#600064);
            .hoverTxt{
              background: linear-gradient(135deg,#c23b59,#600064);
            }
          }
          &.piki{
            background: linear-gradient(135deg,#009ed6,#0348ad);
            .hoverTxt{
              background: linear-gradient(135deg,#009ed6,#0348ad);
            }
          }
          &.womanstalk{
            background: linear-gradient(135deg,#81017f,#3a007e);
            .hoverTxt{
              background: linear-gradient(135deg,#81017f,#3a007e);
            }
          }
          &.infonesia{
            background: linear-gradient(135deg,#ffcc51,#b07534);
            .hoverTxt{
              background: linear-gradient(135deg,#ffcc51,#b07534);
            }
          }
          &.git{
            background: linear-gradient(135deg,#626487,#0d0f3a);
            .hoverTxt{
              background: linear-gradient(135deg,#626487,#0d0f3a);
            }
          }
          &.workbox{
            background: linear-gradient(135deg, #FF922D 0%, #FF5914 100%);
            .hoverTxt{
              background: linear-gradient(135deg, #FF922D 0%, #FF5914 100%);
            }
          }
        }
      }
    }
    .swiper-button-next, .swiper-button-prev {
      top: 36%;
      bottom: 0;
      width: 60px;
      height: 60px;
      background-size: 17px;
      background-color: rgba(194,198,204,.5);
      border-radius: 100%;
      display: none !important;
    }
    .swiper-button-disabled{
      opacity: 0;
    }
  }
  .content6{
    .contain{
      margin-bottom: 523px;
      .picTxt{
        position: relative;
        .pic{
          width: 860px;
        }
        .txt{
          width: 860px;
          background: #ffffff;
          position: absolute;
          right: 0;
          top: 210px;
          box-sizing: border-box;
          padding-top: 60px;
          padding-left: 60px;
          padding-bottom: 60px;
          h3{
            margin-bottom: 20px;
          }
          .text{
            margin-bottom: 40px;
          }
        }
      }
    }
  }
  .modal.fullsize {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;
    display: none;
  }
  .modal.fullsize .modal-dialog, .modal.fullsize .modal-content {
    width: 100%;
    height: 100%;
    margin: 0;
    max-width: none;
    background:#000 ;
  }
  #youtube{
    width:70%;
    height:70%;
  }
  .ttc-youtube-player{
    left: 15%;
    top: 15%;
    position: absolute;
  }
  #headerVideoModal .close {
    position: absolute;
    top: 60px;
    right: 70px;
    font-size: 35px;
    font-weight: 100;
    z-index: 1;
    color: white;
    opacity: 1;
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
  }
  .fade {
    -webkit-transition: opacity .15s linear;
    transition: opacity .15s linear;
  }
}
@media screen and (max-width:1919px){
  .home{
    .content2{
      .contain{
        padding-top: 180px;
        .picTxt{
          padding-left: 193px;
          .pic{
            max-width: 512px;
          }
          .txt{
            margin-bottom: 300px;
          }
        }
      }
    }
    .content3{
      .contain{
        .picTxt{
          margin-bottom: 300px;
          .txt{
            max-width: 560px;
          }
          .pic{
            max-width: 560px;
          }
        }
      }
    }
    .content4{
      .contain{
        .picTxt{
          margin-bottom: 300px;
          .pic{
            width: 560px;
          }
          .txt{
            max-width: 560px;
            padding-top: 85px;
          }
        }
      }
    }
    .content5{
      .contain{
        margin-bottom: 300px;
      }
    }
    .content6{
      .contain{
        .picTxt{
          .pic{
            width: 660px;
          }
          .txt{
            width: 660px;
            top: 150px;
          }
        }
      }
    }
  }
}
@media screen and (max-width:1439px){
  .home{
    .content2{
      .contain{
        padding-top: 90px;
        h1{
          top: 186px;
          max-width: 646px;
        }
        .picTxt{
          .pic{
            max-width: 475px;
          }
          .txt{
            margin-bottom: 260px;
          }
        }
      }
    }
    .content3{
      .contain{
        .max960{
          display: block;
        }
        .picTxt{
          margin-bottom: 260px;
          .txt{
            max-width: 460px;
            .max960{
              display: none;
            }
          }
          .pic{
            max-width: 460px;
          }
        }
      }
    }
    .content4{
      .contain{
        .picTxt{
          margin-bottom: 260px;
          .pic{
            width: 460px;
          }
          .txt{
            max-width: 460px;
            padding-top: 10px;
          }
        }
      }
    }
    .content5{
      .contain{
        margin-bottom: 260px;
      }
    }
    .content6{
      .contain{
        margin-bottom: 380px;
        .picTxt{
          .pic{
            width: 560px;
          }
          .txt{
            width: 560px;
            top: 118px;
          }
        }
      }
    }
  }
}
@media screen and (max-width:1199px){
  .home{
    .content1{
      // background-image: none !important;
      .contain{
        h1{
          margin-bottom: 10px;
        }
      }
    }
    .content2{
      .contain{
        padding-top: 88px;
        h1{
          top: 184px;
        }
        .picTxt{
          .txt{
            margin-bottom: 240px;
          }
        }
      }
    }
    .content3{
      .contain{
        .picTxt{
          margin-bottom: 240px;
          .txt{
            max-width: 360px;
          }
          .pic{
            max-width: 360px;
          }
        }
      }
    }
    .content4{
      .contain{
        .picTxt{
          margin-bottom: 240px;
          .pic{
            width: 360px;
          }
          .txt{
            max-width: 360px;
            padding-top: 0;
          }
        }
      }
    }
    .content5{
      .contain{
        margin-bottom: 240px;
      }
    }
    .content6{
      .contain{
        .picTxt{
          .pic{
            width: 460px;
          }
          .txt{
            width: 500px;
            top: 86px;
          }
        }
      }
    }
  }
}
@media screen and (max-width:760px){
  .home{
    .content1{
      .contain{
        padding-top: 200px;
        p{
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 40px;
        }
        .learn{
          span{
            width: 160px;
            height: 44px;
            line-height: 44px;
            font-size: 16px;
            margin-right: 10px;
          }
          .play{
            width: 44px;
            cursor: pointer;
          }
        }
      }
    }
    .content2{
      .contain{
        padding-top: 60px;
        h1{
          top: 110px;
          left: 20px;
          font-size: 34px;
          line-height: 32px;
        }
        .picTxt{
          padding-left: 0;
          overflow: hidden;
          .pic{
            max-width: 263px;
            float: right;
            margin-bottom: 10px;
          }
          .txt{
            float: left;
            margin-bottom: 200px;
          }
        }
      }
    }
    .content3{
      .contain{
        .max960{
          margin-bottom: 20px;
          h3{
            margin-bottom: 10px;
          }
        }
        .picTxt{
          margin-bottom: 200px;
          .pic{
            max-width: 100%;
            margin-bottom: 20px;
          }
          .txt{
            max-width: 100%;
            .text{
              margin-bottom: 20px;
            }
            .logoIcon{
              width: 40px;
            }
            .mb15{
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    .content4{
      .contain{
        .picTxt{
          margin-bottom: 200px;
          .pic{
            width: 100%;
          }
          .txt{
            max-width: 100%;
            h3{
              margin-bottom: 10px;
            }
            .text{
              margin-bottom: 20px;
            }
            .btns{
              a{
                width: 112px;
                height: 44px;
                line-height: 44px;
                font-size: 16px;
                margin-right: 10px;
              }
            }
          }
        }
      }
    }
    .content5{
      .contain{
        margin-bottom: 200px;
        .swiperBox{
          .slide{
            &:hover{
              .hoverTxt{
                display: none;
              }
            }
          }
        }
      }
      .swiper-button-next, .swiper-button-prev {
        display: block !important;
      }
    }
    .content6{
      .contain{
        .picTxt{
          .pic{
            width: 355px;
            height: 356px;
            margin-left: -20px;
            overflow: hidden;
            img{
              height: 100%;
              width: auto;
              max-width: inherit;
              margin-left: -80px;
            }
          }
          .txt{
            width: 250px;
            padding-top: 20px;
            padding-left: 20px;
            top: 200px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue